import type { ToneOverlay } from "../index.js";

export const overlay: ToneOverlay = {
  "alert.toast.new": "{hazard} por perto. Registado.",
  "alert.toast.escalation": "{hazard} por perto. Piorou.",
  "alert.toast.inPath": "{hazard} a caminho. Claro.",
  "alert.toast.allClear": "Normal outra vez perto de {place}.",
  "alert.toast.tap": "Detalhes, se tiver curiosidade.",
  "alert.takeover.title": "{hazard}. É agora que se move.",
  "alert.takeover.details": "Os detalhes",
  "alert.takeover.dismiss": "Registado",
  "now.status.allClear": "Nada a reportar.",
  "now.status.stayAware": "Olhos abertos.",
  "now.status.sub.allClear": "Nada dentro do seu raio. Aproveite.",
  "now.activity.empty": "Ninguém reportou nada. Suspeito.",
  "onboarding.promise.tagline": "Vizinhos a avisar vizinhos. Revolucionário.",
  "onboarding.promise.continue": "Pronto, vamos lá",
  "onboarding.home.browse": "Só a ver",
  "you.voice.intro": "Escolha o nível de franqueza que prefere.",
};
